module.exports = __webpack_public_path__ + "img/google-login.52337ce9.png";